<ng-container *ngIf="status === PermissionStatus.Accepted" i18n>Accepted</ng-container
><ng-container *ngIf="status === PermissionStatus.Declined" i18n>Declined</ng-container
><ng-container *ngIf="status === PermissionStatus.Pending" i18n>Pending</ng-container>
